export const SET_PROFILE_IMAGE = "SET_PROFILE_IMAGE";
export const SET_OFFICE_IMAGE = "SET_OFFICE_IMAGE";
export const DELETE_PROFILE_IMAGE = "DELETE_PROFILE_IMAGE";
export const DELETE_OFFICE_IMAGE = "DELETE_OFFICE_IMAGE";
export const SET_PROFILE_IMAGE_TYPE = "SET_PROFILE_IMAGE_TYPE";
